import { useIntl, defineMessages } from 'react-intl';

import { CircularProgress } from './circular_progress';

const messages = defineMessages({
  loading: { id: 'loading_indicator.label', defaultMessage: 'Loading…' },
});

type LoadingIndicatorProps = {
  size?: number;
};

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ size = 50 }) => {
  const intl = useIntl();

  return (
    <div
      className='loading-indicator'
      role='progressbar'
      aria-busy
      aria-live='polite'
      aria-label={intl.formatMessage(messages.loading)}
    >
      <CircularProgress size={size} strokeWidth={6} />
    </div>
  );
};
